<template>
  <div
    class="icon-card rounded-lg flex items-center gap-4 py-4 px-6"
  >
    <div class="flex items-center justify-center p-1">
    <font-awesome-icon fixed-width :icon="['far', icon]" size="lg" />
  </div>
    <div>
      <h4 class="text-sm font-bold whitespace-normal">{{title}}</h4>
      <div class="whitespace-normal">
        {{subtitle}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "icon-card",
    props: {
      icon: { type: String, default: '' },
      title: { type: String, default: '' },
      subtitle: { type: String, default: '' },
    },
  }
</script>

<style lang="scss">
  .icon-card {
    background-color: #F8F8F8;

    svg {
      color: #868e96;
    }
  }
</style>
